import { Crosshair } from "@phosphor-icons/react";

export default function LocationPermissionBanner({
  onRetry,
  locating = false,
  usingSaved = false,
  className = "",
}) {
  return (
    <div
      className={[
        "rounded-xl border border-[rgba(184,50,90,0.35)] bg-[rgba(139,30,63,0.14)] px-4 py-3",
        className,
      ].join(" ")}
      data-testid="location-permission-banner"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-[10px] uppercase tracking-[0.22em] text-[#e9b5c5]">
            {usingSaved
              ? "Usando tu última ubicación guardada"
              : "Ubicación desactivada"}
          </p>
          <p className="mt-1 text-[11px] leading-relaxed text-[rgba(255,255,255,0.62)]">
            {usingSaved
              ? "Activa el permiso de ubicación para actualizar tu posición en el mapa."
              : "Necesitamos tu ubicación para mostrar hoteles y encuentros cerca de ti."}
          </p>
        </div>
        <button
          type="button"
          onClick={onRetry}
          disabled={locating}
          className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-[#8B1E3F] px-4 py-2 text-[10px] uppercase tracking-[0.22em] text-[#f5f5f5] transition-colors hover:bg-[#B8325A] disabled:cursor-not-allowed disabled:opacity-60"
          data-testid="location-permission-retry"
        >
          <Crosshair size={14} weight="thin" />
          {locating ? "Solicitando…" : "Activar ubicación"}
        </button>
      </div>
    </div>
  );
}
